// removed by extract-text-webpack-plugin
module.exports = {"container":"index__container--1Xel0","stepperContainer":"index__stepperContainer--3R6ez","wizardPageContainer":"index__wizardPageContainer--2e17I","footer":"index__footer--1Ns8S","footer__button":"index__footer__button--1lb3B"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/Wizard/PopoverDialogWizardContainer/styles/index.scss
// module id = oalf
// module chunks = 23